import React, { Component } from 'react';
// import ReactDOM from 'react-dom';
import ceshi from './components/ceshi';
import Page from './components/Page';
import rule from './components/rule/rule';
//用户隐私规则
import privacyRule from './components/rule/privacyRule';
import postage from "./components/rule/postage"
import shareRule from './components/rule/shareRule';
import flagShip from './components/member/flagShip'
import Futures from './components/rule/futures';
import Share from './components/rule/share';
import spotGoods from './components/rule/spotGoods';
import shipments from './components/rule/shipments';
import earnestMoney from './components/rule/earnestMoney';
import deliveryTime from './components/rule/deliveryTime';
import nonEarnest from './components/rule/nonEarnest';
import Bulletprivacy from './components/rule/Bulletprivacy';
import enterpriseInformation from './components/rule/enterpriseInformation';
import help from './components/help/help';
import Violation from './components/Violation/Violation';
import Punishment from './components/Margin/Punishment/Punishment';
import Already_paid from './components/Margin/Already_paid/Already_paid';
import band_paid from './components/Margin/band_paid/band_paid';
import permanent from './components/Margin/band_paid/permanent';
import penaltiesDetails from './components/Margin/penaltiesDetails/penaltiesDetails';
import Pay_band from './components/Margin/Pay_band/Pay_band';
import advisory from './components/advisory/advisory';
import good from './components/Margin/good/good';
import releasecontent from './components/releasecontent/releasecontent';
import member from './components/member/member';
import membernew from './components/member/membernew';
import menberExplanation from './components/member/menberExplanation';
import contract from './components/member/contract';
import contractTranscript from './components/member/contractTranscript';
import SaleRelease from './components/distribute/SaleRelease/SaleRelease';
import SaleReleaseSeach from './components/distribute/SaleRelease/SaleReleaseSeach';
import BuyingRelease from './components/distribute/SaleRelease/BuyingRelease';
import Increase from './components/distribute/SaleRelease/Increase';
import SaleDetails from './components/distribute/SaleRelease/SaleDetails';

//查号码功能
import checkNumber from './components/checkNumber/checkNumber';
import checkNumberDetils from './components/checkNumber/checkNumberDetils';
import shortVideoActivity from './components/activity/shortVideoActivity';
import saveGoodsImage from './components/activity/saveGoodsImage';
import saveMarketImage from './components/activity/saveMarketImage';
import saveTradeImage from './components/activity/saveTradeImage';
import studentActivity from './components/activity/studentActivity';

// import logo from './logo.svg';
// 配号功能部分
import distribute from "./components/distribute/index/index";
import MyDistribute from "./components/distribute/myDistribute/mydistribute"
import Goods from "./components/distribute/goodsDistribute/goodsdistribute"
import MyStock from "./components/distribute/myStock/mystock"
import SearchNumber from "./components/distribute/search/search"
import SearchResult from "./components/distribute/search/searchResult"
import Preview from "./components/distribute/preview/preview"
import Catalogue from "./components/distribute/catalogue/catalogue"
import CatalogueList from "./components/distribute/catalogue/catalogueList"

import './App.css';

import { Router, Route, } from 'react-router-dom';
import { createHashHistory } from "history";
const hashHistory = createHashHistory();

/* 
Page 总页面入口文件
 rule 规则
 
 Violation 列表
 penaltiesDetails 列表详情 需要跟?satus 刷新消失
 Punishment 处罚展示 /跟用户id  系统自动扣费
 permanent 永久封号 /跟用户id
 band_paid 自然解除 /跟用户id
 Pay_band 待缴纳 /跟用户id
 good 信用良好
 Already_paid 已缴纳 /跟用户id
 
 ---------------
 advisory 交易安全数据保障

 ----------------------------
 App会员信息

 member /跟用户id
 menberExplanation  会员体系升级

 --------------------------
 releasecontent 发布动态文字弹框内容
 releasecontent/1?day=5 发布弹框 day为天数
 releasecontent/2 担保弹框
 releasecontent/3?state=5 会员弹框 state会员的等级
 --------------------------

 帮助
help/member 会员帮助
help/promotion 推广帮助
--------------------------------------------
配号码

BuyingRelease     配号出售发布
SaleRelease       配号求购发布
Increase          增加库存
SaleDetails       增加详情 上传图片
distribute        币票配号，配号功能首页
myDistribute      我的配号
goodsDistribute   商品分类列表
myStock           我的库存
preview           发布预览
searchNumber      配号搜索页
searchResult      配号搜索结果页
publishBtn        发布弹窗页，选择发布类型
Catalogue         配号邮币卡目录
CatalogueList     配号邮币卡目录列表
------------------------------------------------------------------
privacyRule 用户隐私权限
Bulletprivacy 用户隐私权限 弹框



 */
function App() {
    return ( <Router history = { hashHistory } >
        <Route path = "/ceshi" exact component = { ceshi }/>
		<Route path = "/Page/:userId"
			exact component = { Page }/>
		<Route path = "/rule"
			exact component = { rule }/>
		<Route path = "/privacyRule"
			exact component = { privacyRule }/>
		<Route path = "/Bulletprivacy"
			exact component = { Bulletprivacy }/>
		<Route path = "/help/:type"
			exact component = { help }/>
		<Route path = "/Violation/:userId"
			exact component = { Violation }/>
		<Route path = "/Punishment/:userId"
			exact component = { Punishment }/>
		<Route path = "/Already_paid/:userId"
			exact component = { Already_paid }/>
		<Route path = "/band_paid/:userId"
			exact component = { band_paid }/>
		<Route path = "/permanent/:userId"
			exact component = { permanent }/>
		<Route path = "/penaltiesDetails"
			exact component = { penaltiesDetails }/>
		<Route path = "/advisory"
			exact component = { advisory }/>
		<Route path = "/good"
			exact component = { good }/>
		<Route path = "/Pay_band/:userId"
			exact component = { Pay_band }/>
		<Route path = "/member/:userId"
			exact component = { member }/>
		<Route path = "/membernew/:userId"
			exact component = { membernew }/>
		<Route path = "/menberExplanation"
			exact component = { menberExplanation }/>
		<Route path = "/releasecontent/:num"
			exact component = { releasecontent }/>  
	    <Route path = "/SaleRelease"
			exact component = { SaleRelease }/>    
		<Route path = "/SaleReleaseSeach/:ustate"
			exact component = { SaleReleaseSeach }/>    
		<Route path = "/BuyingRelease"
			exact component = { BuyingRelease }/>    
		<Route path = "/Increase"
			exact component = { Increase }/>    
		<Route path = "/SaleDetails"
			exact component = { SaleDetails }/>    
		<Route path = "/distribute"
			exact component = { distribute }/>     
		<Route path = "/myDistribute"
			exact component = { MyDistribute }/>     
		<Route path = "/goodsDistribute"
			exact component = { Goods }/>     
		<Route path = "/myStock"
			exact component = { MyStock }/>     
		<Route path = "/searchNumber"
			exact component = { SearchNumber }/>     
		<Route path = "/searchResult"
			exact component = { SearchResult }/>     
		<Route path = "/preview"
			exact component = { Preview }/>     
		<Route path = "/catalogue"
			exact component = { Catalogue }/>     
		<Route path = "/catalogueList"
			exact component = { CatalogueList }/>     
		<Route path = "/contract/"
			exact component = { contract }/>     
		<Route path = "/contractTranscript/:data"
			exact component = { contractTranscript }/>		
		<Route path = "/futures"
			exact component = { Futures }/>     
		<Route path = "/spotGoods"
			exact component = { spotGoods }/>     
		<Route path = "/shipments"
			exact component = { shipments }/>    
		<Route path = "/earnestMoney"
			exact component = { earnestMoney }/>
		<Route path = "/deliveryTime"
			exact component = { deliveryTime }/>   
		<Route path = "/Share"
			exact component = { Share }/>   
		<Route path = "/flagShip/:userId"
			exact component = { flagShip }/>   
		<Route path = "/nonEarnest"
			exact component = { nonEarnest }/>   
		<Route path = "/postage"
			exact component = { postage }/>
		<Route path = "/shareRule"
			exact component = { shareRule }/>   
		<Route path = "/checkNumber"
			exact component = { checkNumber }/>
		<Route path = "/checkNumberDetils"
			exact component = { checkNumberDetils }/>
		<Route path = "/shortVideoActivity"
			exact component = { shortVideoActivity }/>
		<Route path = "/studentActivity"
			exact component = { studentActivity }/>
		<Route path = "/saveGoodsImage"
			exact component = { saveGoodsImage }/>
		<Route path = "/saveMarketImage"
			exact component = { saveMarketImage }/>
		<Route path = "/saveTradeImage"
			exact component = { saveTradeImage }/>
		<Route path = "/enterpriseInformation"
			exact component = { enterpriseInformation }/>

        </Router>
    );
}

export default App;